import apiClient from '../client';
import type { PaginatedResponse, PaginationParams } from '@/api/types/pagination.types';
import type {
  UserListItem,
  CreateUserRequest,
  UpdateUserRequest,
  ChangePasswordRequest,
  RoleResponse,
} from '@/types/user.types';

export interface UserSearchParams extends PaginationParams {
  search?: string;
  role?: string;
}

export const usersApi = {
  getAll: async (params: UserSearchParams): Promise<PaginatedResponse<UserListItem>> => {
    const response = await apiClient.get<PaginatedResponse<UserListItem>>('/v1/users', { params });
    return response.data;
  },

  getById: async (id: string): Promise<UserListItem> => {
    const response = await apiClient.get<UserListItem>(`/v1/users/${id}`);
    return response.data;
  },

  create: async (request: CreateUserRequest): Promise<UserListItem> => {
    const response = await apiClient.post<UserListItem>('/v1/users', request);
    return response.data;
  },

  update: async (id: string, request: UpdateUserRequest): Promise<UserListItem> => {
    const response = await apiClient.put<UserListItem>(`/v1/users/${id}`, request);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/v1/users/${id}`);
  },

  changePassword: async (id: string, request: ChangePasswordRequest): Promise<void> => {
    await apiClient.post(`/v1/users/${id}/change-password`, request);
  },

  activate: async (id: string): Promise<void> => {
    await apiClient.post(`/v1/users/${id}/activate`);
  },

  deactivate: async (id: string): Promise<void> => {
    await apiClient.post(`/v1/users/${id}/deactivate`);
  },

  getRoles: async (): Promise<RoleResponse[]> => {
    const response = await apiClient.get<RoleResponse[]>('/v1/users/roles');
    return response.data;
  },
};
